<template>
    <flex-element
        :element-type="elementType"
        tag="div"
        class="f-flex"
        @click="emitClickEvent"
    >
        <font-awesome-icon :icon="[renderSet, renderIcon]" :class="iconClasses" />
    </flex-element>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import baseAtom from '@/mixins/base-atom/base-atom-dumb';

export default {
    name: 'a-icon',
    components: { FontAwesomeIcon },
    mixins: [baseAtom],

    props: {
        icon: {
            type: String,
            default: '',
        },

        iconDefault: {
            type: String,
            default: '',
        },

        set: {
            type: String,
            default: '',
        },

        setDefault: {
            type: String,
            default: 'fal',
        },
    },

    computed: {
        iconClasses() {
            return this.htmlClass.filter(className => className.includes('f-rounded'));
        },

        renderSet() {
            return this.set || this.setDefault;
        },

        renderIcon() {
            return this.icon || this.iconDefault;
        },
    },

    methods: {
        emitClickEvent(e) {
            this.$emit('click', e);
        },
    },
};
</script>
